import { createEntityService, currentUser } from './database';

const TABLES = ['workspace_insights','source_records','insight_feedback','inbox_items','learnings','experiment_results','experiments','decisions','notification_history','reminders','evidence','hypotheses','roadmap_items','problem_cards','issues','okrs','time_reflections','time_entries'];
export const clearDataType = async dataType => {
  if (!TABLES.includes(dataType)) throw new Error('Unknown data type');
  const service = createEntityService(dataType);
  const rows = await service.list(dataType === 'issues' ? '-created_date' : '-created_at');
  for (const row of rows) await service.delete(row.id);
  return rows.length;
};
export const clearAllUserData = async () => {
  const user = await currentUser();
  // Stop background imports before clearing, so the scheduler cannot recreate data.
  if (process.env.REACT_APP_DB_PROVIDER === 'firebase') {
    const { integrationsRequest } = await import('../lib/integrations');
    await integrationsRequest('/api/meetings/clear', { body: {} });
    const { getAutopilot, saveAutopilot } = await import('./autopilot');
    const state = await getAutopilot();
    if (state.settings.enabled) await saveAutopilot({ ...state.settings, enabled: false });
  }
  const results = {};
  for (const table of TABLES) results[table] = await clearDataType(table);
  const workspaces = createEntityService('workspaces');
  if (await workspaces.getById(user.id)) await workspaces.update(user.id, { onboarding: {} });
  for (const key of Object.keys(localStorage)) if (key.startsWith(`spcc:user:${user.id}:`)) localStorage.removeItem(key);
  return results;
};
export const resetUserToCleanState = clearAllUserData;
